/**
 * The page, as modules -- and the one place its order is written down.
 *
 * index.html is a shell now (the fonts link, the canvas, the bundle token);
 * every panel, toast and control below builds its own DOM and imports its
 * own CSS, which esbuild emits alongside the JS and build.mjs splices back
 * into the page.  The mount calls run in the order the elements sat in the
 * old file, because document order is load-bearing twice over: equal
 * z-indexes stack by it (#charge, #touch, #bliss and #burr all share z 4),
 * and #pads' column-reverse trick reads its own child order.
 * Same idea as loop.js's STEPS: the order is data -- one thing to read, one
 * thing to diff.
 *
 * `ui` is the handle bag the app composes from.  A module queries only
 * elements it created, so anything one feature needs from another -- the
 * #hud panel debug.js toggles, the #open-customizer button the join card
 * clicks, the #bliss toast happyhud.js fills -- travels as an explicit
 * handle through a constructor, never a global id lookup.
 */
import "./base.css";
import { mountLeftStack } from "./leftstack.js";
import { mountHappy, mountBliss } from "./happy.js";
import { mountHud } from "./hud.js";
import { mountBurr } from "./burr.js";
import { mountChat } from "./chat.js";
import { mountJoin } from "./join.js";
import { mountCustomizerButton, mountCustomizerHost } from "./customizer.js";
import { mountKeys } from "./keys.js";
import { mountLookHint } from "./lookhint.js";
import { mountCharge } from "./charge.js";
import { mountMeowBtn } from "./meow.js";
import { mountTouch } from "./touch.js";
import { mountDebug } from "./debug.js";
import { mountOverlay } from "./overlay.js";

export const ui = {};

// The shell provides exactly one element -- the canvas the game renders
// into.  This lookup is the ui/app seam's half of the bargain: app/ never
// touches an id again.
ui.canvas = document.getElementById("view");

ui.leftStack = mountLeftStack();
Object.assign(ui, mountHappy(ui.leftStack));   // happy, mute
Object.assign(ui, mountHud(ui.leftStack));     // hud, catName, catButtons
ui.openCustomizer = mountCustomizerButton();
ui.keys = mountKeys();
ui.customizerMount = mountCustomizerHost();
ui.lookHint = mountLookHint();
ui.charge = mountCharge();
ui.meowBtn = mountMeowBtn();
ui.touch = mountTouch();
Object.assign(ui, mountDebug());               // debug, debugBody, debugCross, debugToast
Object.assign(ui, mountOverlay());             // loading, overlay, overlayHint
ui.bliss = mountBliss();
ui.burr = mountBurr();
Object.assign(ui, mountChat());                // bubbles, chat
ui.join = mountJoin();
